import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// import axios from '../../utils/axios';
import axios from 'axios';
import urls from '../../url/urls';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  myProfile: null,
  posts: [],
  faq: [],
  faqList: [],
  disclaimer: [],
  alamat: [],
  category: [],
  categoryList: [],
  sertifkat: [],
  sertifikatList: [],
  countstatus: [],
  kpknl: [],
  jadwalelang: [],
  kpknlList: [],
  kantorList: [],
  cpList: [],
  cp: [],
  sortBy: null,
  filters: {
    jaminan: [],
    propinsi: 'All',
    category: 'All',
    colors: [],
    priceRange: '',
    rating: ''
  },
  photoassetList: [],
  provinsiList: [],
  kotaList: [],
  kecList: [],
  kelList: [],
  assets: [],
  asset: [],
  user: [],
  assetList: [],
  countjaminan: [],
  flashsaleList: [],
  hotsaleList: [],
  hotpromoList: [],
  terjualList: [],
  wishListid: [],
  wishList: [],
  advertising: [],
  advertisingList: [],
  notifications: null
};

const slice = createSlice({
  name: 'lelang',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getsertifikatListSuccess(state, action) {
      state.isLoading = false;
      state.sertifikatList = action.payload;
    },
    getCountJaminanSuccess(state, action) {
      state.isLoading = false;
      state.countjaminan = action.payload;
    },
    getcategoryListSuccess(state, action) {
      state.isLoading = false;
      state.categoryList = action.payload;
    },
    getcpListSuccess(state, action) {
      state.isLoading = false;
      state.cpList = action.payload;
    },
    getcpSuccess(state, action) {
      state.isLoading = false;
      state.cp = action.payload;
    },
    getPhotoAssetListSuccess(state, action) {
      state.isLoading = false;
      state.photoassetList = action.payload;
    },
    getAssetlelangSuccess(state, action) {
      state.isLoading = false;
      state.jadwalelang = action.payload;
    },
    getPostCategorySuccess(state, action) {
      state.isLoading = false;
      state.category = action.payload;
    },
    getAdvertisingListSuccess(state, action) {
      state.isLoading = false;
      state.advertisingList = action.payload;
    },
    getProvinsiListSuccess(state, action) {
      state.isLoading = false;
      state.provinsiList = action.payload;
    },
    getKotaListSuccess(state, action) {
      state.isLoading = false;
      state.kotaList = action.payload;
    },
    getKecListSuccess(state, action) {
      state.isLoading = false;
      state.kecList = action.payload;
    },
    getKelListSuccess(state, action) {
      state.isLoading = false;
      state.kelList = action.payload;
    },
    getPostAdvertisingSuccess(state, action) {
      state.isLoading = false;
      state.advertising = action.payload;
    },
    getPostAssetSuccess(state, action) {
      state.isLoading = false;
      state.asset = action.payload;
    },
    getAssetByIdSuccess(state, action) {
      state.isLoading = false;
      state.assets = action.payload;
    },
    getFaqListSuccess(state, action) {
      state.isLoading = false;
      state.faq = action.payload;
    },
    getUserListSuccess(state, action) {
      state.isLoading = false;
      state.user = action.payload;
    },
    getPostWishListSuccess(state, action) {
      state.isLoading = false;
      state.wishList = action.payload;
    },
    getFaqAllListSuccess(state, action) {
      state.isLoading = false;
      state.faqList = action.payload;
    },
    getDisclaimerListSuccess(state, action) {
      state.isLoading = false;
      state.disclaimer = action.payload;
    },
    getAlamatListSuccess(state, action) {
      state.isLoading = false;
      state.alamat = action.payload;
    },
    getKpknlListSuccess(state, action) {
      state.isLoading = false;
      state.kpknlList = action.payload;
    },
    getAssetListSuccess(state, action) {
      state.isLoading = false;
      state.assetList = action.payload;
    },
    getWishListAllSuccess(state, action) {
      state.isLoading = false;
      state.wishList = action.payload;
    },
    getFlashsaleSuccess(state, action) {
      state.isLoading = false;
      state.flashsaleList = action.payload;
    },
    getHotsaleSuccess(state, action) {
      state.isLoading = false;
      state.hotsaleList = action.payload;
    },
    getTerjualSuccess(state, action) {
      state.isLoading = false;
      state.terjualList = action.payload;
    },
    getHotpromoSuccess(state, action) {
      state.isLoading = false;
      state.hotpromoList = action.payload;
    },
    getKantorListSuccess(state, action) {
      state.isLoading = false;
      state.kantorList = action.payload;
    },
    getPostKpklnSuccess(state, action) {
      state.isLoading = false;
      state.kpknl = action.payload;
    },
    getCountStatusSuccess(state, action) {
      state.isLoading = false;
      state.countstatus = action.payload;
    },
    deletekpknlSuccess(state, action) {
      state.isLoading = false;
      state.kpknlList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deletepbidata } = slice.actions;

// ----------------------------------------------------------------------

export function getcategoryList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/category`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getcategoryListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllcategoryList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/categoryAll`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getcategoryListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCpList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/cp`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getcpListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCpListbyKantor(x) {
  return async (dispatch) => {
    const formData = new FormData();
    formData.append('kantor', x);

    const url = `${urls.lelang}/cpList`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(url, formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.getcpListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPhotoAssetList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/photoasset/${x}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getPhotoAssetListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getcountJaminan() {
  return async (dispatch) => {
    const url = `${urls.lelang}/countJaminan`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getCountJaminanSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllsertifikatList() {
  return async (dispatch) => {
    const url = `${urls.lelang}/sertifikatAll`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getsertifikatListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostCategory(values, file) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      console.log(JSON.stringify(values));
      console.log(JSON.stringify(file));
      const formData = new FormData();
      formData.append('file', file);
      formData.append('icons', values.icons);
      formData.append('id', values.id === '' ? 0 : values.id);
      formData.append('category', values.category);
      formData.append('active', values.active);
      formData.append('createdby', values.createdby);

      if (file !== null) {
        response = await axios.post(`${urls.lelang}/newcategories`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        response = await axios.post(`${urls.lelang}/newcategory`, values, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        });
      }

      dispatch(slice.actions.getPostCategorySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostCp(values) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      console.log(JSON.stringify(values));

      const formData = new FormData();
      formData.append('nama_cp', values.nama_cp);
      formData.append('id', values.id === '' ? 0 : values.id);
      formData.append('telp_cp', values.telp_cp);
      formData.append('kantor', values.kantor);
      formData.append('active', values.active);
      formData.append('createdby', values.createdby);

      response = await axios.post(`${urls.lelang}/newcp`, values, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.getcpSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostKpknlname(name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      const formData = new FormData();
      formData.append('name', name);

      response = await axios.post(`${urls.lelang}/kpknlname`, formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.getPostKpklnSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostAdvertising(values, file) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      console.log(JSON.stringify(values));
      console.log(JSON.stringify(file));
      const formData = new FormData();
      formData.append('file', file);
      formData.append('images', values.images);
      formData.append('id', values.id === '' ? 0 : values.id);
      formData.append('description', values.description);
      formData.append('active', values.active);
      formData.append('createdby', values.createdby);

      if (file !== null) {
        response = await axios.post(`${urls.lelang}/savefileAdvertising`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        response = await axios.post(`${urls.lelang}/newAdvertising`, values, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        });
      }

      dispatch(slice.actions.getPostAdvertisingSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostWishlist(name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      const formData = new FormData();
      formData.append('name', name);

      response = await axios.post(`${urls.lelang}/wishlist`, formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.getPostWishListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function loginuser(username, password) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      const formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);

      response = await axios.post(`${urls.lelang}/signin`, formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.getUserListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function PostWishlist(name, idasset, user) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      const formData = new FormData();
      formData.append('name', name);
      formData.append('hp', user.phoneNumber);
      formData.append('nama', user.displayName);
      formData.append('idasset', idasset);

      response = await axios.post(`${urls.lelang}/sendwishlist`, formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.PostWishListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostPage(values, file) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      console.log(JSON.stringify(values));
      console.log(JSON.stringify(file));
      const formData = new FormData();
      formData.append('file', file);
      formData.append('title1', values.title1);
      formData.append('title2', values.title2);
      formData.append('id', values.id === '' ? null : values.id);
      formData.append('contents', values.contents);
      formData.append('headerimage', values.headerimage);
      formData.append('createdby', values.createdby);
      formData.append('type', values.type);

      if (file !== null) {
        response = await axios.post(`${urls.lelang}/savefilepage`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        response = await axios.post(`${urls.lelang}/savepage`, values, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        });
      }

      dispatch(slice.actions.getFaqListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostPhotoAsset(values, file) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('posisi', values.posisi);
      formData.append('utama', values.utama);
      formData.append('idasset', values.idasset);
      formData.append('id', values.id === '' ? null : values.id);
      formData.append('docfilenm', values.docfilenm);
      formData.append('createdby', values.createdby);

      if (file !== null) {
        response = await axios.post(`${urls.lelang}/savePhotoAsset`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        response = await axios.post(`${urls.lelang}/savePhotoAssetTanpaFile`, values, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        });
      }
      const urlss = `${urls.lelang}/photoasset/${values.idasset}`;
      const responses = await axios.get(urlss);
      dispatch(slice.actions.getPhotoAssetListSuccess(responses.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostProvinsi(tipe, nama) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      const formData = new FormData();
      formData.append('tipe', tipe);
      formData.append('nama', nama);

      response = await axios.post(`${urls.lelang}/provkel`, formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (tipe === 'prov') {
        dispatch(slice.actions.getProvinsiListSuccess(response.data));
      } else if (tipe === 'kota') {
        dispatch(slice.actions.getKotaListSuccess(response.data));
      } else if (tipe === 'kec') {
        dispatch(slice.actions.getKecListSuccess(response.data));
      } else if (tipe === 'kel') {
        dispatch(slice.actions.getKelListSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAdvertisingList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/advertising/${x}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getAdvertisingListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getKantorList() {
  return async (dispatch) => {
    const url = `${urls.lelang}/kantor`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getKantorListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getasetlelang() {
  return async (dispatch) => {
    const url = `${urls.lelang}/asetlelang`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getAssetlelangSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFaqList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/faq`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getFaqListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getProsedurList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/prosedur`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getFaqListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFaqAllList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/pageAll`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getFaqAllListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getDisclaimerList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/disclaimer`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getDisclaimerListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAlamatList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/alamat`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getAlamatListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getKpknlList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/kpknl`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getKpknlListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllKpknlList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/kpknlAll`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getKpknlListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCountStatus() {
  return async (dispatch) => {
    const url = `${urls.lelang}/countStatus`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getCountStatusSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostKpknl(values) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      response = await axios.post(`${urls.lelang}/newkpknl`, values, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.getPostKpklnSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostAsset(values) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      response = await axios.post(`${urls.lelang}/newasset`, values, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.getPostAssetSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostAssetStatus(values) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let response = null;
      response = await axios.post(`${urls.lelang}/assetstatus`, values, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      dispatch(slice.actions.getPostAssetSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAktivasi(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/aktivasi/${x}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.hasError(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllAssetList(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/assetAll`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getAssetListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getWishListAll(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/wishlistall`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getWishListAllSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getListAsset() {
  return async (dispatch) => {
    const url = `${urls.lelang}/listAsset`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getAssetListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getListAssetbyJenis(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/listAssetbyJenis/${x}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getAssetListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFlashsale(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/flashsale`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getFlashsaleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getHotsale(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/hotsale`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getHotsaleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getHotpromo(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/hotpromo`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getHotpromoSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTerjual(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/terjual`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getTerjualSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAllAssetStatus(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/assetStatus/${x}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getAssetListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAssetById(x) {
  return async (dispatch) => {
    const url = `${urls.lelang}/assetById/${x}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);

      dispatch(slice.actions.getAssetByIdSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteKpknl(x) {
  return async (dispatch) => {
    console.log('Proses Delete');
    const url = `${urls.lelang}/delkpknl/${x}`;
    const urlss = `${urls.lelang}/kpknlAll`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);
      const responses = await axios.get(urlss);
      dispatch(slice.actions.deletekpknlSuccess(responses.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteKategori(x) {
  return async (dispatch) => {
    console.log('Proses Delete');
    const url = `${urls.lelang}/delkategori/${x}`;
    const urlss = `${urls.lelang}/categoryAll`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);
      const responses = await axios.get(urlss);
      dispatch(slice.actions.getcategoryListSuccess(responses.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteCp(x) {
  return async (dispatch) => {
    console.log('Proses Delete');
    const url = `${urls.lelang}/delcp/${x}`;
    const urlss = `${urls.lelang}/cp`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);
      const responses = await axios.get(urlss);
      dispatch(slice.actions.getcpListSuccess(responses.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteAsset(x) {
  return async (dispatch) => {
    console.log('Proses Delete Asset');
    const url = `${urls.lelang}/delasset/${x}`;
    const urlss = `${urls.lelang}/assetAll`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);
      const responses = await axios.get(urlss);
      dispatch(slice.actions.getAssetListSuccess(responses.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function delphotoaset(x, y) {
  return async (dispatch) => {
    console.log('Proses Delete Photo Asset');
    const url = `${urls.lelang}/delphotoaset/${x}`;
    const urlss = `${urls.lelang}/photoasset/${y}`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);
      const responses = await axios.get(urlss);
      dispatch(slice.actions.getPhotoAssetListSuccess(responses.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteAdvertising(x) {
  return async (dispatch) => {
    console.log('Proses Delete');
    const url = `${urls.lelang}/deladvertising/${x}`;
    const urlss = `${urls.lelang}/advertising/All`;
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(url);
      const responses = await axios.get(urlss);
      dispatch(slice.actions.getAdvertisingListSuccess(responses.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
